// extracted by mini-css-extract-plugin
export default {"dividerLine":"HeaderMetadataDivider-module__dividerLine--Unh8g"};